import { type ReactNode } from 'react';
import './PageHeader.css';

export interface PageHeaderProps {
  /** Page title */
  title: string;
  /** Optional subtitle text */
  subtitle?: string;
  /** Actions (buttons, etc.) aligned to the end */
  actions?: ReactNode;
  /** Additional class names */
  className?: string;
}

function PageHeader({
  title,
  subtitle,
  actions,
  className = '',
}: PageHeaderProps) {
  const classes = ['page-header', className].filter(Boolean).join(' ');

  return (
    <header className={classes}>
      <div className="page-header-text">
        <h1 className="page-header-title">{title}</h1>
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-header-actions">{actions}</div>}
    </header>
  );
}

export default PageHeader;
